import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  fetchSingleScenario,
  triggerScenariosInit,
  triggerScenarios,
  saveTypologySegments,
  fetchScenarioTypologies,
  hideValidationErrors,
  refreshScenarioValidation
} from '../../../redux/actions/trm/trmDashboard';
import { getCategories, getLiveSets } from '../../../redux/actions/settings';
import {
  fetchThresholdStatus,
  fetchThresholdResults,
  fetchThresholdConfig,
  triggerThresholdGeneration,
  discardThresholdGeneration,
  thresholdGenerationReset
} from '../../../redux/actions/trm/thresholdGeneration';
import ConfigureScenario from './configureScenario';

function mapStateToProps(state) {
  const { trmDashboard = {}, settings = {} } = state;
  /*
   * Create Run instance reducers:
   * - typologySegment
   */
  const { singleScenario = {}, typologySegment = {} } = trmDashboard;
  const { createRunInstanceCategories = {}, createRunInstanceLiveSets = {} } =
    settings;
  const { isLoading, data, error } = singleScenario;
  return {
    isLoading,
    error,
    scenario: data,
    authentication: state.authentication,
    createRunInstanceCategories, // look at this for category list
    trmDashboard, // look at this for typology list fetched
    typologySegment, // look at this for saving typology segment sets
    createRunInstanceLiveSets, //look at this for combinations of sets
    thresholdGeneration: state.thresholdGeneration,
    // FIN-11803: Launch-gate modal state populated by the validate-before-
    // launch saga (FIN-11800).
    scenarioValidationErrors: trmDashboard.scenarioValidationErrors
  };
}

function mapDispatchToProps(dispatch) {
  return {
    scenarioAPIActions: bindActionCreators(
      {
        fetchSingleScenario,
        triggerScenariosInit,
        triggerScenarios,
        hideValidationErrors,
        refreshScenarioValidation
      },
      dispatch
    ),
    // look here for create run instance related actions
    configureRunInstanceAPIActions: bindActionCreators(
      {
        saveTypologySegments,
        getCategories,
        fetchScenarioTypologies,
        getLiveSets
      },
      dispatch
    ),
    thresholdGenerationActions: bindActionCreators(
      {
        fetchThresholdStatus,
        fetchThresholdResults,
        fetchThresholdConfig,
        triggerThresholdGeneration,
        discardThresholdGeneration,
        thresholdGenerationReset
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfigureScenario);
